<script>
import isEqual from 'lodash.isequal'

import ResetGrid from '~/components/ResetGrid.vue'
import SegmentedControl from '~/ui/elements/SegmentedControl.vue'

export default {
  name: 'FilterBar',
  components: {
    ResetGrid,
    SegmentedControl
  },
  props: {
    /** Provide context if an external condition has changed to toggle reset button */
    hasChangedState: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    modelValue: {
      type: Object,
      required: true
    },
    /** the ag-grid column to filter on */
    field: {
      type: String,
      required: true
    },
    items: {
      type: Object,
      required: true
    }
  },
  emits: ['reset', 'update:modelValue'],
  computed: {
    filterValue: {
      get () {
        const hasAllOptionsSelected = this.modelValue?.[this.field]?.values?.length === Object.keys(this.items).length - 1
        return hasAllOptionsSelected
          ? 'ALL'
          : this.modelValue?.[this.field]?.values?.[0]?.toUpperCase() || 'ALL'
      },
      set (newValue) {
        const newFilters = {
          ...this.modelValue,
          [this.field]: newValue === 'ALL'
            ? undefined
            : {
                values: [newValue],
                filterType: 'set'
              }
        }
        if (isEqual(newFilters, this.modelValue)) return
        this.$emit('update:modelValue', newFilters)
      }
    },
    hasFilters: ({ modelValue }) => Object.keys(modelValue).length > 0,
    showReset: ({ hasChangedState, hasFilters }) => hasChangedState || hasFilters
  }
}
</script>

<template>
  <div class="enterprise-filter-bar d-flex flex-row align-center justify-space-between">
    <div class="enterprise-filter-bar__container align-center d-flex">
      <VSkeletonLoader
        v-if="loading"
        class="d-flex mx-3"
        type="chip"
      />
      <SegmentedControl
        v-else
        v-model="filterValue"
        :items="items"
        class="mx-3"
        size="small"
      />
    </div>
    <div class="px-4 d-flex ga-4 align-center">
      <ResetGrid
        v-if="showReset"
        :loading="loading"
        @reset="$emit('reset')"
      />
      <slot name="actions" />
    </div>
  </div>
</template>

<style lang="scss">
@use '~/styles/mixins' as *;
@use 'vuetify/settings' as vuetifySettings;

.enterprise-filter-bar {
  @include z-index(secondary-menu);

  background: #FFF;
  border-bottom: 1px solid #DADCE0;

  &__container {
    min-height: 56px;
  }

  .v-btn-toggle--segmented.sticky-filter {
    .v-btn__content {
      font-size: 14px;
      line-height: 14px;
    }
  }

  .v-skeleton-loader__chip {
    width: vuetifySettings.$skeleton-loader-chip-width;
  }
}
</style>
